/**
 * Parametros enviados conocidos
 * @param {string} contentGroup
 * @param {string} contentType
 * @param {string} itemId
 * @param {string} event
 * @param {string} trackContentGroup
 */

export function puerSendTrackingInfo(data) {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
}
